// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce52e2a9","453":"710913b8","455":"5cbbe226"}[chunkId] + ".chunk.js";
};